// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import { Alert, Button, Container, Stack, Title } from '@mantine/core';
import type { JSX } from 'react';
import { useSearchParams } from 'react-router';
import { getProviderAppEnvConfig } from '../../config/env';

export function InviteExpiredPage(): JSX.Element {
  const config = getProviderAppEnvConfig();
  const supportEmail = config.supportEmail;
  const [searchParams] = useSearchParams();
  const isReset = searchParams.get('mode') === 'reset';

  const heading = isReset ? 'Reset Link Expired' : 'Invitation Link Expired';
  const alertTitle = isReset ? 'Reset Link Expired or Invalid' : 'Invitation Link Expired or Invalid';
  const alertMessage = isReset
    ? 'Your reset link has expired or is invalid. Return to sign in to request a new reset link, or contact support if you still need help.'
    : 'Your invitation link has expired or is invalid. Please contact your administrator to request a new invite.';

  return (
    <Container size="xs" mt="xl">
      <Stack gap="md">
        <Title order={2}>{heading}</Title>

        <Alert color="yellow" title={alertTitle}>
          {alertMessage}
        </Alert>

        {supportEmail ? (
          <Button component="a" href={`mailto:${supportEmail}`} fullWidth>
            Email Support
          </Button>
        ) : (
          <Alert color="gray" title="Unable to Contact Support">
            Support email is not configured. Please contact your administrator directly.
          </Alert>
        )}
      </Stack>
    </Container>
  );
}
